const footerTools = {
    size: $(window).outerWidth() < 768 ? 'mob' : 'desk',
    desk: $('.js_footer__wrapper'),
    mob: $('.js_footer__main-mob'),
    el: $('.js_footer__main'),

    init: function() {
        if (footerTools.size == 'mob') {
            footerTools.mob.append(footerTools.el)
        }
    },

    adapt: function () {
        const width = $(window).outerWidth()
        if (width < 768 && footerTools.size == 'desk') {
            footerTools.mob.append(footerTools.el)
            footerTools.size = 'mob'
        } else if (width >= 768 && footerTools.size == 'mob') {
            console.log('here')
            footerTools.desk.prepend(footerTools.el)
            footerTools.size = 'desk'
        }
    }
}

$(document).ready(() => {
    footerTools.init()
})

$(window).on('resize', () => {
    footerTools.adapt()
})